import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import type { OnChanges, SimpleChanges } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppService, AuthService } from '@shared/services';
import { WebComponentsLoaderService } from '@shared/webcomponents/webcomponents-loader/webcomponents-loader.service';
import { distinctUntilChanged, filter } from 'rxjs';
import { environment } from '@env/environment';

export interface ObservationRecorderConfig {
  id: string;
  defaults?: Record<string, string>;
}

@UntilDestroy()
@Component({
  selector: 'app-cw-observations',
  template: `
    <rc-cw-observations
      class="widget"
      [attr.projectid]="projectId"
      [attr.sdk]="{
        token: token$ | async,
        url: url,
      } | json"
      [attr.progressaiurl]="progressAIUrl"
      [attr.callsign]="'unknown'"
      [attr.config]="config | json"
    ></rc-cw-observations>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 60vh;
      }
      .widget {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CWObservationRecorderComponent implements OnChanges {
  @Input() id: string;
  @Input() defaults: Record<string, string>;

  token$ = this.authService.token$.pipe(filter(Boolean), distinctUntilChanged());

  url = new URL(environment.api.url).hostname;
  projectId = this.appService.projectId;
  config: ObservationRecorderConfig;
  protected readonly progressAIUrl = environment.droneDeploy?.progressAIApi;

  constructor(
    private webComponentLoader: WebComponentsLoaderService,
    private cdr: ChangeDetectorRef,
    public appService: AppService,
    private authService: AuthService,
  ) {
    this.webComponentLoader.loadDefaultComponents();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes) return;
    this.updateObservationRecorder();
  }

  private updateObservationRecorder = () => {
    if (!this.id) return;
    this.config = {
      id: this.id,
      defaults: this.defaults,
    };
    this.cdr.markForCheck();
  };
}
